import { useRef } from "react"
import {
  Turnstile as ReactTurnstile,
  TurnstileInstance,
} from "@marsidev/react-turnstile"

import { env } from "@/lib/env"
import { turnstileErrorAction } from "@/lib/turnstile"
import { ClientRender } from "@/components/client-render"

export interface TurnstileProps {
  id: string
  onSuccess: (token: string) => void
  onError?: (errorCode: string) => void
  onExpire?: () => void
  onUnsupported?: () => void
  onScriptLoadError?: () => void
}

function InternalTurnstile({
  id,
  onSuccess,
  onError,
  onExpire,
  onUnsupported,
  onScriptLoadError,
}: TurnstileProps) {
  const turnstile = useRef<TurnstileInstance>(null)
  const siteKey = env("NEXT_PUBLIC_CF_TURNSTILE_SITE_KEY")

  if (!siteKey) {
    return null
  }

  function handleError(errorCode: string) {
    onError?.(errorCode)

    if (turnstileErrorAction(errorCode) === "reset") {
      turnstile.current?.reset()
    }
  }

  return (
    <ReactTurnstile
      id={id}
      ref={turnstile}
      options={{ theme: "light" }}
      siteKey={siteKey}
      key={siteKey}
      onSuccess={onSuccess}
      onError={handleError}
      onExpire={onExpire}
      onUnsupported={onUnsupported}
      scriptOptions={{ onError: onScriptLoadError }}
    />
  )
}

// must be client rendered as it loads a js script
export function Turnstile(props: TurnstileProps) {
  return (
    <ClientRender>
      <InternalTurnstile {...props} />
    </ClientRender>
  )
}
